<template>


  <div class="text-xs-center">
    <v-dialog v-model="dialog" max-width="550">
      <template v-slot:activator="{ on }">
        <v-btn small flat color="error" dark v-on="on">retirer</v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Retrait Btc</v-card-title>
        <v-card-text>
          <v-alert type="error" dismissible :value="true">
            Saisir le montant exact à recevoir
          </v-alert>
          <v-form ref="form" v-if="formulaire">
            <vs-row class="my-4">
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" w="7">
                <vs-input class="num_input mr-5"
                type="number"
                label-placeholder="Montant exact à recevoir"
                size="normal"
                v-model="amount"
                style="font-size:1.6em; font-weight: 700;"
              />
              </vs-col>

              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" w="5">
               <span><v-btn color="primary" @click="tout">Max</v-btn></span>
              </vs-col>
            </vs-row>


            <v-flex xs12 text-xs-center mt-4>
              <span >Frais Réseau: {{fee}} </span> <span class="ml-5 font-weight-bold">Total: {{total}}  </span>
            </v-flex>
          
            <vs-input
              class="my-4 wallet_input"
              :danger="btcAddr.length>0 && !validHash"
              danger-text="Adresse BTC invalide"
              label-placeholder="BTC Adresse"
              size="large"
              v-model="btcAddr"
              
            />
            <v-flex xs12 text-xs-center>
              <v-btn type="submit" :disabled ="!validHash" color="success" @click.prevent="submit() ">Retirer</v-btn>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <p class="red--text subheader" v-if="hmm">solde insuffisant</p>
            </v-flex>
            <div class="caption red--text">Hiropay n'est pas responsable en cas d'adresse erronée</div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="dialog = false">fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

          <div>
            <v-dialog v-model="dialog_2fa"  max-width="800">
              <v-card>
                <v-card-title class="headline grey lighten-2 pa-3" primary-title>
                  <div style="display:block; text-align:center; margin:auto;">Google 2-FA</div>
                </v-card-title>

                <v-card-text class="px-3 pt-1 mb-4">
                  <div style="display:block; max-width:100%; text-align:center">
                      <img src="/img/2fa.svg" width="70" alt=""  >
                  </div>
                  <p
                    class="caption"
                    style="display:block; max-width:100%; text-align:center"
                  >Entrez le code à 6 chiffres pour confirmer le retrait</p>
                  <div class="pl-4" style="text-align:center">
                    <input
                      class="code"
                      v-model="code"
                      type="number"
                      onkeypress="if(this.value.length==6) return false;"
                    />
                    <br />
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog_2fa= false">fermer</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { log } from "util";
import axios from 'axios'
var bcrypt = require("bcryptjs");
export default {
  data() {
    return {
      btcAddr: "",
      validHash:false,
      formulaire: true,
      dialog: false,
      fee: 0,
      dialog_2fa:false,
      amount: '',
      total:'',
      code:'',
      pass: process.env.VUE_APP_SECRET,
      hmm: false,
      yep: false,
      nameRules: [v => !!v || "required"],
      btcRules: [
        v => /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/.test(v) || "invalid address", 
        v => !!v || "required"
      ]
    };
  },
  computed: {
    ...mapGetters({
      btc: "authfb/btc",
      user:"authfb/user"
    })
  },
  watch: {
    code(newValue, oldValue) {
      if (newValue.length == 6) {
        this.validate();
      }else{
        this.total = 0
      }
    },
    amount(newValue, oldValue){
      this.debouncedFee()
    },

    btcAddr(newValue, oldValue){
      this.validHash= /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/.test(this.btcAddr)? true: false
    }
  },

  created: function() {
    this.debouncedFee = _.debounce(this.setFee, 200);
  },

  mounted () {
    
  },
  methods: {
    async tout(){
      let btc= Number(this.$store.getters["authfb/btc"])
      this.amount= btc
      await this.setFee()
      let send = btc - Number(this.fee)
      console.log(this.amount, this.fee);
      this.amount= parseInt(send*1000000)/1000000
    },

    setFee(){
      
      switch (true) {
        case ( 0 < this.amount && this.amount <= 0.002 ): this.fee = 0.00005
          break;
        case ( 0.002 < this.amount && this.amount <= 0.01 ): this.fee = 0.0001
          break;
          case ( 0.01 < this.amount && this.amount <=0.03 ): this.fee = 0.0002
          break;

          case ( 0.03 < this.amount && this.amount <= 0.05 ): this.fee = 0.00025
          break;

          case ( 0.05 < this.amount && this.amount <= 0.1 ): this.fee = 0.00038
          break;

          case (this.amount > 0.1 ): this.fee = 0.00045
          break;

        default: this.fee=0
          break;
      }

      this.total = new Intl.NumberFormat("en-US",{maximumFractionDigits:8}).format(Number(this.amount)+this.fee)
    },

    async dispatch_withdraw(){
      let send_amount = Number(this.amount)
      let total_amount = send_amount + Number(this.fee)
        this.$store
                  .dispatch("withdraw/retraitBtc", {
                    sendAmount: send_amount,
                    adress: this.btcAddr,
                    amount: total_amount,
                    fee: Number(this.fee),
                    coinbase_api: `${this.base_url}/instant/coinbase_send`,
                    base_url:this.base_url,
                    pass: this.pass,
                    vm:this
                  })
                  .then(() => {
                    this.formulaire = false;
                    this.yep = true;
                    this.amount='';
                    this.btcAddr='';
                    setTimeout(() => {
                      this.formulaire = true;
                      this.yep = false;
                    }, 5000);
                  });
    },

    submit() {
      if (this.validHash&& this.fee > 0) {
        if (this.amount < 0.0005) {
          swal("Retrait minimum 0.0005 BTC", "veillez changer le montant", "error", {
              button: "ok",
            });
          return
        }

        let btc=this.$store.getters["authfb/btc"]
        let send_amount = Number(this.amount)
        let total_amount = send_amount + Number(this.fee)

        console.log(btc, send_amount, total_amount);

        if (total_amount<=btc && send_amount > 0){
          this.dialog = false;

           if (this.user.auth2fa.google) {
            this.dialog_2fa=true;
            return
          }

          swal({
            text: "CODE PIN",
            content: {
              element: "input",
              attributes: {
                placeholder: "Enter PIN",
                type: "password",
              },
            },
            button: {
              text: "confirm",
              closeModal: false
            }
          }).then(value => {
            var hash = this.$store.getters["authfb/pin"];
            bcrypt.compare(value, hash).then(res => {
              if (res){
                this.dispatch_withdraw()
              } else {
                swal("incorrect PIN!", "", "error", {
                  button: "ok"
                });
                this.dialog = true;
              }
            });
          });
        } else {
          this.hmm = true;
          setTimeout(() => {
            this.hmm = false;
          }, 2000);
        }
      }else{
        swal("Erreur","Saisie incorrecte", "error", {
                button: "ok!"
              })
      }
    },
    validate(){
      let token = this.code
        let valid = this.verify_2fa(token)
        console.log(valid);

        if (valid) {
          this.dialog_2fa=false;
             this.dispatch_withdraw()

             const noti = this.$vs.notification({
                  color: 'success',
                  position: 'top-right',
                  title: 'Success',
                  text: '2FA correct, retrait en cours'
                })
          }else{
              swal("code 2FA invalide!","", "error", {
                button: "ok!"
              })
              this.code=''
          }
    }
  }
};
</script>

<style scoped>
.vs-input {
  width: 95%;
}
.vs-input.wallet_input {
  width: 500px !important;
}
.vs-input.num_input {
  max-width: 190px !important;
  font-size: 2em;
  display: inline-block;
}
input.swal-content__input {
  color: black;
}
</style>
